import { render } from "./PayrollOther.vue?vue&type=template&id=bcd96784&ts=true"
import script from "./PayrollOther.vue?vue&type=script&lang=ts"
export * from "./PayrollOther.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__